export enum Languages {
    EN = 'en',
}
